<app-home-hero></app-home-hero>
<app-product-category-cards></app-product-category-cards>
<div class="bg:grey-5 p-32:t md:p-72:t lg:p-96:t">
    <div class="narrow-container">
        <h1 class="align:c">Unsere Highlights</h1>
        <div class="grid-container -equal-h">
            @for (teaserCard of teaserCards; track $index) {
                <a
                    appTeaserCard
                    class="g-12 md:g-6"
                    [routerLink]="teaserCard.path"
                    [teaserCard]="teaserCard"
                ></a>
            }
        </div>
    </div>
    <app-introduction></app-introduction>
    <app-service-portal></app-service-portal>
</div>
<app-partnerships></app-partnerships>
